import { useMemo } from 'react'
import { TransmitterMesh } from '@scene'
import { useHiddenElements } from '@editor/hooks'
import { useControlStore, useModelStore, useTransmissionStore } from '@editorStores'
import useEmitModelClickListenerV2 from '../hooks/useEmitModelClickListenerV2'
import { useModelMeshStore } from '../state/store'

interface Props {
  disableClick?: boolean
}

const TensileTransmittersMesh = ({ disableClick }: Props) => {
  const tensileTransmissionGraph = useTransmissionStore(state => state.tensileTransmissionGraph)
  const domains = useModelStore(state => state.domains)

  const hiddenGuids = useModelMeshStore(state => state.hiddenGuids)
  const hiddenTransmitterElementIdGroups = useControlStore(
    state => state.hiddenTensileTransmitterElementIdGroups,
  )

  const selectedElements = useModelMeshStore(state => state.selectedGuids)

  const visibleTransmitterElementGuids = useModelMeshStore(
    state => state.visibleTensileTransmitterElementGuids,
  )

  const executeListener = useEmitModelClickListenerV2()

  const hiddenElements = useHiddenElements()

  const allHiddenGuids = useMemo(() => {
    return new Set([
      ...hiddenElements,
      ...Array.from(hiddenGuids.values()).flat(),
      ...Object.values(hiddenTransmitterElementIdGroups).flat(),
    ])
  }, [hiddenElements, hiddenGuids, hiddenTransmitterElementIdGroups])

  const allVisibleTransmitterElementGuids = useMemo(() => {
    return Array.from(visibleTransmitterElementGuids.values()).flat()
  }, [visibleTransmitterElementGuids])

  const allSelectedGuids = useMemo(() => {
    return Array.from(selectedElements.values()).flat()
  }, [selectedElements])

  return (
    <group visible={allVisibleTransmitterElementGuids.length > 0}>
      <TransmitterMesh
        data={tensileTransmissionGraph}
        domains={domains}
        transmitterGuid={allSelectedGuids.length ? (allSelectedGuids[0] as string) : undefined}
        onClick={({ guid, element_guid }, event) =>
          executeListener('global-tensile-transmitter-mesh', event, {
            type: 'tensile_transmitter',
            elementGuid: element_guid,
            transmitterGuid: guid,
          })
        }
        elementGuids={allVisibleTransmitterElementGuids}
        hiddenElements={allHiddenGuids}
        disableClick={allVisibleTransmitterElementGuids.length === 0 || disableClick}
      />
    </group>
  )
}

export { TensileTransmittersMesh }
